import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Select from "@mui/material/Select";
import { useSelector } from "react-redux";
import { nhlPackTypes } from "src/utils/cardUtils";
import { get, post } from "src/utils/networkUtils";

export default function AddPackDialog(props) {
  const [packType, setPackType] = useState(null);
  const [packTypes, setPackTypes] = useState(null);
  const [tenantId, setTenantId] = useState(1);

  const tenants = useSelector((state) => state.tenant.tenants);

  useEffect(() => {
    get(`/admin/packs/types`).then(function (response) {
      setPackTypes(
        response.packTypes.filter((pack) => nhlPackTypes.includes(pack.value))
      );
    });
  }, []);

  const onSuccess = () => {
    props.setLoading(true);
    props.onClose();
    post(`/admin/packs/generate`, {
      userId: props.userId,
      packType,
      tenantId,
    }).then(function (response) {
      props.onSuccessHandler();
    });
  };
  const onCancel = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Add Pack</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={8} sx={{ m: 0, p: 1 }}>
            <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
              <InputLabel id="demo-simple-select-label">Pack Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={packType}
                label="Pack Type"
                onChange={(event) => setPackType(String(event.target.value))}
              >
                {packTypes !== null &&
                  packTypes.map((item, index) => (
                    <MenuItem
                      value={item.value}
                      key={`competition-${item.value}`}
                    >
                      {item.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={8} sx={{ m: 0, p: 1 }}>
            <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
              <InputLabel id="tenant-select-label">Tenant</InputLabel>
              <Select
                labelId="tenant-select-label"
                id="tenant-select"
                value={tenantId}
                label="Tenant"
                onChange={(event) => setTenantId(Number(event.target.value))}
              >
                {tenants && tenants.map((tenant) => (
                  <MenuItem
                    value={tenant.tenantId}
                    key={`tenant-${tenant.tenantId}`}
                  >
                    {tenant.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button
          onClick={() => onSuccess()}
          autoFocus
          disabled={packType === null}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
